import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const AuthorizationVoteSearchPersonCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Ricerca Persona - Autorizzazione al voto',
    path: '/sportello/autorizzazione-voto',
  },
];

export const AuthorizationVoteCrumbs = [
  ...AuthorizationVoteSearchPersonCrumbs,
  {
    name: 'Autorizzazione al voto',
    path: '/sportello/autorizzazione-voto/stampa',
  },
];
